export const ROLES = {
    ADMIN: "ADMIN",
    INVENTORY_MANAGEMENT: "INVENTORY_MANAGEMENT",
    CALCULATOR: "CALCULATOR",
    EMPLOYEE: "EMPLOYEE",
    SUPER_ADMIN: "SUPER_ADMIN",
}